import React, { useState } from 'react';
import { Box, Container, Image, Modal, ModalBody, ModalCloseButton, ModalContent, ModalOverlay, SimpleGrid, Text } from '@chakra-ui/react';
import { SectionHeading } from './SectionHeading';
import { gallery, type GalleryItem } from '../data/gallery';
export function Gallery() {
  const [active, setActive] = useState<GalleryItem | null>(null);
  return <Box as="section" id="galeria" bg="plum.950" py={{
    base: 14,
    md: 24
  }} data-id="element-107" data-mp="2pn0uu7x56x9t">
      <Container maxW="76rem" px={{
      base: 4,
      md: 6
    }} data-id="element-108" data-mp="2pl7pcvy9mj3e">
        <SectionHeading eyebrow="Nuestro espacio" title="GALERÍA" description="Imágenes de nuestro templo y de los elementos tradicionales que acompañan cada consulta." tone="dark" data-id="element-109" data-mp="2kps8rw8vi93a" />

        <SimpleGrid columns={{
        base: 1,
        sm: 2,
        lg: 3
      }} spacing={{
        base: 4,
        md: 6
      }} mt={{
        base: 10,
        md: 14
      }} data-id="element-110" data-mp="2ukkb1ddehk4e">
          {gallery.map(item => <Box key={item.src} as="button" type="button" onClick={() => setActive(item)} aria-label={`Ampliar imagen: ${item.caption}`} position="relative" display="block" w="100%" textAlign="left" borderRadius="xl" overflow="hidden" border="1px solid" borderColor="whiteAlpha.300" transition="all 0.25s ease" _hover={{
          borderColor: 'gold.300',
          transform: 'translateY(-3px)'
        }} data-id="element-111" data-mp="21xpswn422wu3">
              <Image src={item.src} alt={item.alt} w="100%" h={{
            base: '15rem',
            md: '17rem'
          }} objectFit="cover" loading="lazy" data-id="element-112" data-mp="dew5c3e0er7a" />
              <Box position="absolute" inset={0} bg="linear-gradient(180deg, rgba(13,6,19,0) 45%, rgba(13,6,19,0.85) 100%)" aria-hidden="true" data-id="element-113" data-mp="1su20hvy2r1gy" />
              <Text position="absolute" bottom={4} left={5} right={5} fontSize="sm" fontWeight={500} color="cream.50" data-id="element-114" data-mp="3tuqbmr0nimqb">
                {item.caption}
              </Text>
            </Box>)}
        </SimpleGrid>
      </Container>

      <Modal isOpen={active !== null} onClose={() => setActive(null)} size="xl" isCentered data-id="element-115" data-mp="3b50jycs6qh2m">
        <ModalOverlay bg="rgba(13,6,19,0.9)" data-id="element-116" data-mp="36673cbhlq9y8" />
        <ModalContent bg="plum.900" borderRadius="xl" mx={4} overflow="hidden" data-id="element-117" data-mp="367i7iceyljpv">
          <ModalCloseButton color="cream.50" zIndex={2} data-id="element-118" data-mp="3kvd6gajk8kbe" />
          <ModalBody p={0} data-id="element-119" data-mp="3kwwn4294oxdp">
            {active && <Box data-id="element-120" data-mp="3g3lbzoxa9ufz">
                <Image src={active.src} alt={active.alt} w="100%" objectFit="contain" data-id="element-121" data-mp="3g324l259eog7" />
                <Text px={5} py={4} fontSize="sm" color="plum.100" data-id="element-122" data-mp="2sd7tap0l97y2">
                  {active.caption}
                </Text>
              </Box>}
          </ModalBody>
        </ModalContent>
      </Modal>
    </Box>;
}